import algosdk from 'algosdk';
import config from '../client.json';

const host = `${config.scheme}://${config.host}`;
export default new algosdk.Algodv2(config.token, host, config.port);

// export const indexer TODO

// export default new algosdk.Algodv2("",'https://node.algoexplorerapi.io', '')
